// ContentPreviewModal
import React, { useState } from 'react';
import Modal from '../Modal';
import cn from 'classnames';
import styles from './ContentPreviewModal.module.sass';
import Video from '../Video';
import { MediaType } from 'types/media';

export interface ContentPreviewModalProps {
  type: MediaType;
  contentPath: string;
  thumbnailUrl?: string;
  previewClassName?: string;
  modalContainerClassName?: string;
  alt: string;
  contentModalHeader?: JSX.Element;
  contentModalFooter?: JSX.Element;
  onOpen?: () => void;
  onClose?: () => void;
}

const ContentPreviewModal: React.FC<ContentPreviewModalProps> = ({
  type,
  contentPath,
  thumbnailUrl,
  previewClassName,
  modalContainerClassName,
  alt,
  contentModalHeader,
  contentModalFooter,
  onOpen,
  onClose,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (onOpen) onOpen();
    setOpen(true);
  };
  const handleClose = () => {
    if (onClose) onClose();
    setOpen(false);
  };

  return (
    <>
      <link href={contentPath} as="image" rel="preload" />
      <button
        onClick={handleOpen}
        className={cn(styles.previewContent, previewClassName)}
      >
        {type === 'video' && (
          <img
            alt="play button"
            src="https://trend-production.s3.us-east-2.amazonaws.com/assets/play-button.svg"
            className={styles.videoPlayButton}
          />
        )}
        {type === 'video' ? (
          <VideoThumbnail
            contentPath={contentPath}
            thumbnailUrl={
              thumbnailUrl === contentPath ? undefined : thumbnailUrl
            }
            alt={alt}
          />
        ) : (
          <img src={thumbnailUrl || contentPath} alt={alt} />
        )}
      </button>
      <Modal open={open} onBackdropClick={handleClose} className={styles.modal}>
        <button
          className={cn(styles.contentCard, modalContainerClassName)}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={styles.closeButton} onClick={handleClose}>
            <i className="icon-close-filled" />
          </button>
          {contentModalHeader}
          <div className={styles.content}>
            {type === 'image' ? (
              <img src={contentPath} alt={alt} />
            ) : (
              <Video
                src={contentPath}
                autoPlay={true}
                disablePictureInPicture
              />
            )}
          </div>
          {contentModalFooter}
        </button>
      </Modal>
    </>
  );
};

export default ContentPreviewModal;

const VideoThumbnail: React.FC<
  Pick<ContentPreviewModalProps, 'contentPath' | 'thumbnailUrl' | 'alt'>
> = ({ contentPath, thumbnailUrl, alt }) => {
  const [thumbnailError, setThumbnailError] = useState(false);
  const onThumbNailError = () => {
    setThumbnailError(true);
  };
  return thumbnailUrl && !thumbnailError ? (
    <img src={thumbnailUrl} alt={alt} onError={onThumbNailError} />
  ) : (
    <video src={`${contentPath}#t=1`} disablePictureInPicture tabIndex={-1} />
  );
};
